import React from 'react';
import { Marker } from '@react-google-maps/api';

interface IGoogleMapMarkerBasicComponentProps {
    position: google.maps.LatLngLiteral;
};

const GoogleMapMarkerBasicComponent = (props: IGoogleMapMarkerBasicComponentProps) => {
    return (
        <Marker position={props.position} />
    );
};

export default GoogleMapMarkerBasicComponent;
